<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>
                                  <e-column field='user_img_url' width='60' headerText='' :allowSorting='false' :allowFiltering='false' :template='imgPersonTemplate'></e-column>  
                                  <e-column field='user_id' headerText='系統帳號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                  <e-column field='user_name' headerText='人員姓名' width='160' ></e-column>   
                                  <e-column field='limit_name' headerText='權限' width='160' ></e-column>   
                                  <e-column field='sign' headerText='簽名' width='140' :template="SignTemplate" ></e-column>  
                                  <e-column field='user_name_en' headerText='英文姓名' width='160' ></e-column>  
                                  <e-column field='dept_name' headerText='部門名稱' width='140'></e-column>
                                  <e-column field='email' headerText='電子信箱' width='250'></e-column>
                                  <e-column field='phone' headerText='電話' width='140'></e-column>
                                  <e-column field='cellphone' headerText='手機號碼' width='140'></e-column>
                                  <e-column field='preson_id' headerText='員工編號' width='140'></e-column>
                                  <e-column field='memo' headerText='註記' width='200'></e-column>
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>

                                </e-columns>
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增人員資料" : "修改人員資料" + (e_state == 1 ? "(啟用中)" : "(停用中)")' :buttons='e_buttons' 
                        width='500px'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                               
                                <div class="form-group col-md-6">
                                  <span class="about-title" style="vertical-align: top; ">人員圖片</span>
                                  <label class="btn btn-ghost-success" style="vertical-align: top;">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                  </label>
                                  <div class="c-avatar" style="height:50px; padding-left: 10px; text-align:left"><img v-bind:src="e_user_img_url" style="height:50px;" class="c-avatar-about-img" /></div>   
                                </div>
                                <div class="form-group col-md-6">                                 
                                  <br/>
                                  姓別：                                  
                                  <ejs-radiobutton label="男" name="sex" :value="'0'" :checked="e_sex == 0" @change="onSexChange"></ejs-radiobutton>&nbsp; &nbsp; &nbsp; &nbsp; 
                                  <ejs-radiobutton label="女" name="sex" :value="'1'" :checked="e_sex == 1" @change="onSexChange"></ejs-radiobutton>
                                </div>                                            
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">系統帳號</span>
                                  <ejs-textbox floatLabelType="Always" cssClass="my-textbox"  v-model="e_user_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>  
                                </div>                               
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">所屬部門</span>
                                  <ejs-dropdownlist id='depts' cssClass="custom-dropdown"  :dataSource='deptDatas' :fields='fields' v-model="e_dept_id" ></ejs-dropdownlist>
                                </div>
                                 <div class="form-group col-md-4">
                                  <span class="about-title-verify">權限</span>
                                  <ejs-dropdownlist id='limit' cssClass="custom-dropdown"  :dataSource='limitDatas' :fields='fields' v-model="e_limit_id" ></ejs-dropdownlist>
                                </div>
                                <div class="form-group col-md-6">   
                                  <span class="about-title-verify">人員名稱</span>
                                  <ejs-textbox floatLabelType="Always" cssClass="my-textbox" v-model="e_user_name" aria-required="true"></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-6">
                                  <span class="about-title">英文名稱</span>
                                  <ejs-textbox floatLabelType="Always" cssClass="my-textbox" v-model="e_user_name_en" aria-required="true"></ejs-textbox>    
                                </div>                                    
                                <div class="form-group col-md-6">
                                  <span class="about-title">電子信箱</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_email"  aria-required="true"></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title-verify">員工編號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_preson_id"  aria-required="true"></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title">電話號碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_phone"  aria-required="true"></ejs-textbox>    
                                </div>
                                <div class="form-group col-md-6">
                                  <span class="about-title">手機號碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_cellphone"  aria-required="true"></ejs-textbox>    
                                </div>   
                                <div class="form-group col-md-12">
                                  <span class="about-title">註記</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_memo" aria-required="true"></ejs-textbox>    
                                </div>   
                            </div>
                        </div>                
                    </ejs-dialog>
                    <ejs-dialog ref="modalPwdDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='"變更" + e_name + "密碼"' :buttons='dialog_buttons' 
                      width='600px'>
                      <div formGroup="orderForm">                   
                          <div class="form-row">
                              <div class="form-group col-md-12">
                                <ejs-textbox id='txtpwd' floatLabelType="Auto" placeholder="請輸入密碼" :type="passwordType1" v-model="e_pwd" aria-required="true" style="width: 100%; padding-right: 40px; box-sizing: border-box;"></ejs-textbox>
                                <span @click="switchVisibility(1)" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 24px; text-align: center; z-index: 10;">
                                  <img v-if="passwordType1 === 'password'" src="img/icon/eye-solid.svg" width="20px"/>
                                  <img v-else src="img/icon/eye-closed.svg" width="20px"/>
                                </span>
                              </div> 
                              <div class="form-group col-md-12">
                                <ejs-textbox id='txtpwd2' floatLabelType="Auto" placeholder="再次確認密碼" :type="passwordType2" v-model="e_pwd2" aria-required="true" style="width: 100%; padding-right: 40px; box-sizing: border-box;"></ejs-textbox>    
                                <span @click="switchVisibility(2)" style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer; width: 24px; text-align: center; z-index: 10;">
                                  <img v-if="passwordType2 === 'password'" src="img/icon/eye-solid.svg" width="20px"/>
                                  <img v-else src="img/icon/eye-closed.svg" width="20px"/>
                                </span>
                              </div>
                          </div> 
                      </div>                
                  </ejs-dialog> 
                </div>    
            </div>
            <ejs-dialog ref="dialogSign" showCloseIcon='true' isModal='true' :visible='false'  width='680px' closeOnEscape='true' >
                <SignTemplate ref="OwnerSignTemplate" v-on:onSignClose="onSignTemplateItem" style="justify-content: center; "></SignTemplate>
            </ejs-dialog>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script>

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { RadioButtonComponent } from "@syncfusion/ej2-vue-buttons";
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";
import SignTemplate from "./Sign.vue";
setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);
Vue.prototype.$eventHub = new Vue(); 
let DialogObj   = undefined;
let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent,
    'ejs-radiobutton': RadioButtonComponent,
      SignTemplate
  },
  data: function () {
    return {
      limit : localStorage.getItem('system'), 
      e_pwd: null, e_pwd2: null,
      e_selectRow : null, e_selectData: null,
      e_user_id: null, e_user_name : null,  e_dept_id: null, e_email: null, e_isAdd: null, e_no: null, e_name: null, e_state: null, e_phone: null, e_cellphone: null,
      e_user_img_url: null, e_user_img: null, e_preson_id: null, e_user_name_en: null, e_memo : null, e_limit_id : null,
      e_sex: null,
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],
      fields: { value: 'value', text: 'text' },
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: null, deptDatas: null, limitDatas: null,
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      dialog_buttons: [{
          click: this.dialog_editOkClick,
          buttonModel: { content: '確認更改密碼', isPrimary: true } 
        }, { 
          click: function() { this.hide(); }, 
          buttonModel: { content: '取消', isPrimary: false}
      }],
      SignTemplate: function () {
        return {
            template: Vue.component('SignTemplate', {
                template: `<div id="coordinates">
                        <span id="locationtext"><img :src="data.sign_url"  style="width:60px; height:auto; background-color:#f0f0f0; padding:4px; border-radius:4px;"/><a @click="doSomething" href="#"><img src="img/icon/pen.png" class="e-image" width="20px"/></a></span>  
                        </div>`,
                data: function () { return { data: {} }; },
                computed: { },
                methods: {
                    doSomething(e) {
                            e.preventDefault(); 
                        this.$eventHub.$emit('SetHeader',"簽名");  
                        this.$eventHub.$emit('sign',this.data);                               
                    }                          
                }
            })
        }
      },
      imgPersonTemplate: function () { return { 
          template: Vue.component("imgPersonTemplate", {
          template:  `<div><img :src="image" class='c-avatar-about-img' style='width:30px' /></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.user_img_url;
              }
          }
      })}},
      passwordType1: 'password', passwordType2: 'password',
    };
  },
  methods: {    
    switchVisibility(target) {
      if (target === 1) {
        this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password';
      } else if (target === 2) {
        this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password';
      }
    },
    toolbarClick: function (args) {
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除${this.e_selectData.user_name}的資料嗎?`,
            okButton: {  text: 'Yes', click: this.delOkClick },
            cancelButton: {  text: 'No', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Start' || args.item.id == 'Stop' ) {
        DialogObj = DialogUtility.confirm({
            title: '狀態變更',
            content: `確認是否要${this.e_state == 0 ? '啟用' : '停用'}${this.e_selectData.user_name}的資料嗎?`,
            okButton: {  text: 'Yes', click: this.statusOkClick },
            cancelButton: {  text: 'No', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    
        this.e_isAdd = true;
        this.e_user_id = ""; this.e_user_name = "";
        this.e_dept_id = this.deptDatas[0].value; this.e_email = ""; this.e_sex = 0; 
        this.e_user_img_url = ""; this.e_user_img = ""; this.e_preson_id = "";
        this.e_presonid_name = ""; this.e_cellphone = ""; this.e_phone = "";
        this.e_user_name_en = ""; this.e_memo = "";   this.e_limit_id = null;
        this.$refs.modalDialog.show();
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick();
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'使用者資料.xlsx' });
      }   
      if (args.item.id == "Change") {
        this.$refs.modalPwdDialog.show();
      }
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },
    onSexChange: function(args) {
      this.e_sex = args.event.target.value;
    },          
    checkHeader: function() {       
      this.toolbar = this.e_state == 0 ? 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false || this.limit.indexOf('22') < 0},
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined  || this.limit.indexOf('22') < 0},
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined  || this.limit.indexOf('22') < 0},
        { text: '啟用', tooltipText: '啟用', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'Start', disabled: this.e_selectRow == undefined  || this.limit.indexOf('22') < 0},
        { text: '變更密碼', tooltipText: '變更密碼', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Change', disabled: this.e_selectRow == undefined  || this.limit.indexOf('22') < 0 },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'] : 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false || this.limit.indexOf('22') < 0 },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined || this.limit.indexOf('22') < 0 },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined || this.limit.indexOf('22') < 0 },
        { text: '停用', tooltipText: '停用', prefixIcon: 'e-btn-icon e-circle e-icons e-icon-left', id: 'Stop', disabled: this.e_selectRow == undefined || this.limit.indexOf('22') < 0 },
        { text: '變更密碼', tooltipText: '變更密碼', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Change', disabled: this.e_selectRow == undefined || this.limit.indexOf('22') < 0  },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search']
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');  
      this.e_selectData = args.data;     
      this.e_name = this.e_selectData.user_name;
      this.e_state = this.e_selectData.state == 1; 
      this.checkHeader();
    },
    //sign
        onSignTemplateItem:function() {
        this.$refs.dialogSign.hide(); 
        this.getUserAccountData();
    },
    dialog_editOkClick: function () {  
      if (this.e_pwd != this.e_pwd2) {  
        this.e_msg = "兩者密碼不相同,請重新輸入"
        return
      }
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/MyPwd',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            user_id: this.e_selectData.user_id,
            user_pwd: this.e_pwd
          }
        })
        .then((response) => {             
          if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); this.hideLoading(); return; } 
          this.$refs.modalPwdDialog.hide();          
          this.showMsg(`密碼已修正,請於下次登入時使用新密碼`);  
          this.e_pwd = "";
          this.e_pwd2 = "";
        })
        .catch((error) => {this.showError(error, true)}
      )        
    },
    statusOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/State',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            user_id: this.e_selectData.user_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('修改成功!');         
        this.hideLoading();
        this.getUserAccountData();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },    
    fileImageChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/User/Upload',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) { 
          self.e_user_img = response.data.datas;
          self.e_user_img_url = response.data.msg;
  
      
      }).catch((error) => { this.showError(error, false) })
    },  
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/User',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            user_id: this.e_selectData.user_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getUserAccountData();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },         
    delCancelClick: function() {
        DialogObj.hide();
    },    
    editOkClick: function() {     
      this.showLoading();
      this.axios({
          method: this.e_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/User',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            user_id: this.e_user_id,
            user_name: this.e_user_name,   
            dept_id: this.e_dept_id,
            preson_id:  this.e_preson_id,            
            email: this.e_email,
            state: this.e_state ? 1 : 2,          
            sex : this.e_sex,
            phone : this.e_phone,
            cell_phone : this.e_cellphone,
            user_img : this.e_user_img,            
            user_name_en : this.e_user_name_en,
            memo : this.e_memo,
            limit_id : this.e_limit_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg(this.e_isAdd ? '新增成功，密碼請在Email取得。' : '修改成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getUserAccountData();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 

    },  
    recordDoubleClick: function () {         
      if (this.limit.indexOf('22') < 0) return;
      this.e_isAdd = false;
      this.e_user_id = this.e_selectData.user_id;  this.e_user_name = this.e_selectData.user_name;  this.e_preson_id = this.e_selectData.preson_id; 
      this.e_dept_id = this.e_selectData.dept_id;  this.e_email = this.e_selectData.email;
      this.e_state = this.e_selectData.state == 1;
      this.e_user_img_url = this.e_selectData.user_img_url ; this.e_user_img = this.e_selectData.user_img;
      this.e_presonid_name = this.e_selectData.preson_name; this.e_cellphone = this.e_selectData.cellphone; this.e_phone = this.e_selectData.phone;
      this.e_user_name_en = this.e_selectData.user_name_en; this.e_memo = this.e_selectData.memo;
      this.e_limit_id = this.e_selectData.limit_id;
      this.e_sex = this.e_selectData.sex;     
      this.$refs.modalDialog.show();   
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    getUserAccountData: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/User',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas;
  
          this.e_selectRow = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    getDeptData: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'Account/Department',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                    
          this.deptDatas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLimeit(){
      this.axios({
          method:'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url:'/Limit?no=true',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }
        this.limitDatas = response.data.datas;
      })
      .catch((error) => { 
        this.$refs.toastRef.show( { title: '錯誤!', content: error, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
      })
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getDeptData();
    this.getLimeit();
    this.getUserAccountData();
     this.$eventHub.$on('sign', ()=>{ 
      // console.log("Hello")
        this.$refs.dialogSign.show();
      }); 
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
    this.$eventHub.$off('sign');
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
